<template>
    <div style="  background: #eeeeee;height: 100vh;">
        <div class="wrap">
            <van-sticky>
                <van-nav-bar title="充值明细" left-arrow @click-left="$router.go(-1)" />
            </van-sticky>
            <!-- 列表 -->
            <div class="recordList" v-if='list.length>0'>
                <div class="recordItem" v-for='(item,index) in list' :key='index'>
                    <div class="itemLeft">
                        <div class="itemType">
                            <span v-if='item.type==2'>支付宝</span>
                            <span v-if='item.type==3'>微信</span>
                            <span v-if='item.type==1'>银行卡</span>充值
                        </div>
                        <div class="itemTime">
                            {{item.create_time}}
                        </div>
                    </div>
                    <div class="itemRight">
                        <div>
                            <span style="color:#FF6600;" v-if='item.status==0'>审核中</span>
                            <span style="color:#1E33FF" v-if='item.status==1'>充值成功</span>
                            <span style="color:#FF0000;" v-if='item.status==2'>充值失败</span>
                        </div>
                        <div class="itemMoney">
                            {{item.money}}积分
                        </div>
                    </div>
                </div>
            </div>
            <div class="noData" v-else>暂无数据</div>
        </div>
    </div>
</template>

<script>
    import { remittanceRecordList } from "@/api/personal";
    export default {
        data() {
            return {
                list: [],
            };
        },
        created() {
            remittanceRecordList().then(resp => {
                this.list = resp;
            })
        },
    };
</script>
<style lang='less' scoped>
    .wrap {
        height: 100%;

        .recordList {
            width: 100%;
            background: #fff;
            box-sizing: border-box;
            padding: 0 15px;
            margin: 0 auto;

            .recordItem {
                display: flex;
                justify-content: space-between;
                color: #333;
                padding: 15px 0 16.5px;
                border-bottom: 1px solid #eee;
                font-size: 14px;

                .itemTime {
                    margin-top: 15px;
                    color: #999;
                    font-size: 12px;
                }

                .itemMoney {
                    margin-top: 11px;
                }
            }
        }
    }
</style>